<sc-flex vertical fitHeight stretchContent>
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="transportdarstellungsregel bearbeiten"></sc-dictionary-label>
  </sc-dialog-title>
  <sc-padding leftRightOnly>
    <sc-formular-component [model]="rule"
      [context]="{layout: detailLayout!, detailLayoutItemProvider: detailLayoutItemProvider!}"></sc-formular-component>
  </sc-padding>
  <sc-flex-fitting-content vertical>
    <sc-padding fitHeight>
      <cext-conditions-editor [condition]="condition" [anchors]="anchors"></cext-conditions-editor>
    </sc-padding>
  </sc-flex-fitting-content>
  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="cancel()"></sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button primary (click)="confirm()"></sc-confirm-button>
  </sc-actionbar>
</sc-flex>
